import type { FaireProductEntity } from "../../entity_types/product";

export const p_t9zfq6yd5t: FaireProductEntity = {
  token: "p_t9zfq6yd5t",
  type: "product",
  name: '"Thank You" Thank You Greeting Card – Foil & Embossed',
  brandToken: "b_hkkchf48fc",
  brandName: "Short and Sweet",
  imageUrl:
    "https://cdn.faire.com/fastly/480ab8eed93609da5446d0baa1f8e7328585526e2afba96d2486dda2b56066f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/caea45a28d17403c0c157643b3ba60130d515edac3c140f859b999a235be21e2.png",
    "https://cdn.faire.com/fastly/a7d74478100618655e67ed2c60c7777cabd3c1a9cd980a1adf15d3ffa901a701.jpeg",
    "https://cdn.faire.com/fastly/8c6bb9fb8a672706c932cb668de6b6282fca09584a01b733003dda73fed531ba.jpeg",
    "https://cdn.faire.com/fastly/034c22c0bbae2de93132a5aba1efde4078d5f22ac41f6cb30047232fcd7af8e0.jpeg",
  ],
  priceDollars: 1.99,
  description:
    'This foil-embossed greeting card features the classic message “Thank You,” a simple and heartfelt way to show appreciation and gratitude. Designed in a petite 3.5" × 4.75" format, it delivers a sincere sentiment in a beautifully compact card.\n\nThe compact size makes it perfect for pairing with small gifts, thoughtful gestures, or tokens of appreciation, while the premium foil and embossed finishes add a polished detail shoppers notice instantly.\n\nFeatures\n\n• 3.5” × 4.75” greeting card\n• Blank inside for a personal message\n• Foil and embossed finish on the card front\n• Includes foil embellished envelope\n• Individually packaged in protective cello wrap\n• Printed on premium cardstock\n• Perfect for gifting, checkout displays, and impulse purchases\n\nRetailer Notes\n\nThese compact greeting cards are designed for quick emotional connection and strong impulse sales. Their small footprint makes them ideal for checkout displays and gift pairings where shoppers often pick up two or three at a time.\n\nSKU: 790-04572-000',
  tags: [],
  msrpDollars: 3.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:54.980Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
